import { useState } from "react";
import * as yup from 'yup';

const useHandleForm = (data, showWeightSpecificSkills, createCallback, modifyCallback, invalidDataCallback) => {

  const isCreate = !Boolean(data);

  const createInitialData = () => {

    const getInitialFieldData = (fieldName) => {
      return isCreate ? "" : data[fieldName];
    }

    const fieldNames = [
      "name",
      "group",
      "description",
      "weighted",
      "skillClass",
    ];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: getInitialFieldData(fieldName)
      })
    }, {});
  }

  const [formData, setFormData] = useState(createInitialData());

  const dataIsValid = async () => {
    const nameRegex = /^[a-zA-ZÑÁÉÍÓÚ][a-zA-Z0-9ÑÁÉÍÓÚ]*/;

    let schema = yup.object().shape({
      name: yup.string().matches(nameRegex).required(),
      description: yup.string().required(),
      group: yup.string().matches(nameRegex).required(),
      weighted: showWeightSpecificSkills ? yup.string().required() : yup.string(),
      skillClass: yup.string().required(),
    });

    const schemaIsValid = await schema.validate(formData, { abortEarly: false })
      .then((castData) => castData)
      .catch(err => {
        if (err instanceof yup.ValidationError) {
          err.inner.forEach(error => {
            console.log(error.message);
          });
          return false;
        }
      });

    if (schemaIsValid) return !showWeightSpecificSkills || !(formData.weighted > 100);
    return schemaIsValid
  }

  const submit = async () => {
    if (await dataIsValid()) {
      let dataToSend = { ...formData };

      isCreate ? createCallback(dataToSend) : modifyCallback({ ...dataToSend, code: data.code });
      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const setFormValue = (value, fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: value,
    })
  }

  return { isCreate, formData, setFormValue, submit };
}

export default useHandleForm;